import MedicalReportTemplateConfig from "@/views/configs/medical_report_template/index.vue";

export default [
  {
    path: "relatorio-medico",
    name: "Relatório Médico",
    component: MedicalReportTemplateConfig,
  },
];
